var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchAmazonApiGateway32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture/32/Arch_ Amazon-API-Gateway_32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0084D",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4F8B",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture/32/Arch_-Amazon-API-Gateway_32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon-Service/32/Amazon-API-Gateway_32",
    transform: "translate(4.000000, 4.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,24.0000333 L17,24.0000333 L17,23.0000333 L15,23.0000333 L15,24.0000333 Z M10,3.26212734 L3,6.30211286 L3,26.3570173 L10,28.7960057 L10,3.26212734 Z M11,9.00010001 L11,23.0000333 L13,23.0000333 L13,24.0000286 L11,24.0000286 L11,29.5000024 C11,29.6620016 10.922,29.8140009 10.79,29.9080004 C10.704,29.9680002 10.603,30 10.5,30 C10.444,30 10.389,29.991 10.336,29.9720001 L2.336,27.1850134 C2.135,27.1150137 2,26.9260146 2,26.7130157 L2,5.97411442 C2,5.77511537 2.118,5.59511623 2.301,5.5161166 L10.301,2.04213315 C10.455,1.97513347 10.634,1.9901334 10.774,2.08213296 C10.915,2.17413252 11,2.33213177 11,2.50013097 L11,8.00010477 L13,8.00010477 L13,9.00010001 L11,9.00010001 Z M29,6.30211286 L22,3.26212734 L22,8.00010477 L22,9.00010001 L22,23.0000333 L22,24.0000286 L22,28.7960057 L29,26.3570173 L29,6.30211286 Z M30,5.97411442 L30,26.7130157 C30,26.9260146 29.865,27.1150137 29.664,27.1850134 L21.664,29.9720001 C21.611,29.991 21.556,30 21.5,30 C21.397,30 21.296,29.9680002 21.21,29.9080004 C21.078,29.8140009 21,29.6620016 21,29.5 L21,24.0000286 L19,24.0000286 L19,23.0000333 L21,23.0000333 L21,9.00010001 L19,9.00010001 L19,8.00010477 L21,8.00010477 L21,2.50013097 C21,2.33213177 21.085,2.17413252 21.226,2.08213296 C21.367,1.9891334 21.546,1.97413347 21.699,2.04213315 L29.699,5.5161166 C29.882,5.59511623 30,5.77511537 30,5.97411442 L30,5.97411442 Z M15,9.00010477 L17,9.00010477 L17,8.00010477 L15,8.00010477 L15,9.00010477 Z M19.975,11.6580874 L19.025,11.3420889 L16.025,20.342046 L16.975,20.6580445 L19.975,11.6580874 Z M15.146,18.8540531 L12.146,15.8540674 C11.951,15.6580683 11.951,15.3420698 12.146,15.1460707 L15.146,12.146085 L15.854,12.8540817 L13.207,15.5000691 L15.854,18.1460565 L15.146,18.8540531 Z",
    id: "Amazon-API-Gateway_Icon_32_Squid"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchAmazonApiGateway32);
export default __webpack_public_path__ + "static/media/Arch_ Amazon-API-Gateway_32.2277d2cb0d5c2a4132a13cddcc063c0a.svg";
export { ForwardRef as ReactComponent };